var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15745 6.86298L9.32205 2.50281C9.59989 1.94307 10.4027 1.94307 10.6806 2.50281L12.8451 6.86298L17.6859 7.56648C18.307 7.65674 18.5545 8.41584 18.1049 8.85126L14.6027 12.2428L15.4292 17.0342C15.5354 17.6495 14.8858 18.1187 14.3301 17.8281L10.0013 15.5647L5.67253 17.8281C5.1168 18.1187 4.46721 17.6495 4.57335 17.0342L5.39985 12.2428L1.89776 8.85126C1.44811 8.41584 1.69565 7.65674 2.31674 7.56648L7.15745 6.86298Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty-star.6dec0c76c34d2418d8c795bb45e19976.svg";
export { ForwardRef as ReactComponent };